import r from "../../shared-lib/braze-shared-lib.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag.At.ns] && "boolean" == typeof e[FeatureFlag.At.Fe])
    return new FeatureFlag(
      e[FeatureFlag.At.ns],
      e[FeatureFlag.At.Fe],
      e[FeatureFlag.At.we]
    );
  r.D.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.hs.ns] && "boolean" == typeof e[FeatureFlag.hs.Fe])
    return new FeatureFlag(
      e[FeatureFlag.hs.ns],
      e[FeatureFlag.hs.Fe],
      e[FeatureFlag.hs.we]
    );
  r.D.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`
  );
}
